"use client";

import { Modal } from "@/components/modal";
import dynamic from "next/dynamic";
import type { PnlChartShade, PnlChartTrade, PnlChartIndex } from "@/components/pnl-chart";

const PnlChart = dynamic(() => import("@/components/pnl-chart"), { ssr: false });

/**
 * Profit/(loss)-over-time modal for one account. Open when `account` is
 * non-null; sized like the shared price-chart modal.
 */
export function PnlChartModal({
  account,
  onClose,
  height = "75vh",
  zIndex,
}: {
  account: { name: string; since: string; trades: PnlChartTrade[]; shade?: PnlChartShade | null; indices?: PnlChartIndex[]; start?: number; until?: string } | null;
  onClose: () => void;
  height?: string;
  zIndex?: number;
}) {
  return (
    <Modal open={!!account} onClose={onClose} width="90vw" maxWidth="1200px" maxHeight="90vh" zIndex={zIndex}>
      {account && (
        <div className="flex flex-col" style={{ height, width: "100%" }}>
          <PnlChart name={account.name} since={account.since} trades={account.trades} shade={account.shade} indices={account.indices} start={account.start} until={account.until} onClose={onClose} className="flex-1 min-h-0" />
        </div>
      )}
    </Modal>
  );
}
